/* global axios */

import ApiClient from './ApiClient';

// Tela "Conectar o Claude": consentimento do login OAuth (nível do usuário).
class McpOauthAPI extends ApiClient {
  constructor() {
    super('mcp_oauth/authorization', { accountScoped: false });
  }

  details(params) {
    return axios.get(this.url, { params });
  }

  decide(payload) {
    return axios.post(this.url, payload);
  }
}

export default new McpOauthAPI();
